/** Tool name for artifact export — kept free of UI/chat imports to avoid cycles. */
export const EXPORT_ARTIFACT_TOOL_NAME = "export_artifact";
